export default __webpack_public_path__ + "static/pie-with-variable-radius-98efad4116fb8b33e6c9b367facc98fb.png";